/**
 * An unknown /account path. It sits inside the account shell, so it does not pass for a working
 * account page, and it tells a signed-out visitor the address is wrong before asking them to sign in.
 */
import * as stylex from "@stylexjs/stylex";
import { useEffect, useState } from "react";
import "@lattice/tokens/color.stylex";
import { color } from "@lattice/tokens/color.stylex";
import "@lattice/tokens/space.stylex";
import { space } from "@lattice/tokens/space.stylex";
import { LinkButton } from "@lattice/ui/LinkButton";
import { loadSession } from "../api.ts";
import { AskedAddress, useNoIndex } from "../NotFound.tsx";
import { AccountShell } from "./Shell.tsx";
export function AccountNotFound() {
  useNoIndex();
  const [signedIn, setSignedIn] = useState(false);
  useEffect(() => {
    document.title = "Page not found · Lattice";
    /* The shell's heading takes focus, as the other not-found pages' do, so a screen reader reads
       where the visitor landed. It is not a control, so it gets no ring. */
    const heading = document.querySelector("main h1");
    if (heading instanceof HTMLElement) {
      heading.tabIndex = -1;
      heading.style.outlineStyle = "none";
      heading.focus();
    }
    void loadSession().then(loaded => {
      setSignedIn(loaded.status === "ok" && !loaded.me.anonymous);
    });
  }, []);
  return <AccountShell title="We can't find that account page" showSignOut={signedIn}>
      <p className="x1ghz6dp x1jty25b">
        The address may be mistyped, or the page may have moved. Nothing in your account was
        changed.
      </p>
      <AskedAddress />
      <div className="x78zum5 x1a02dak x626il7">
        <LinkButton href="/account" size="md">
          Back to your account
        </LinkButton>
        <LinkButton href="/support" tone="quiet" size="md">
          Contact support
        </LinkButton>
      </div>
    </AccountShell>;
}